import React from "react";
import PropTypes from "prop-types";

const Loading = () => {
  return (
    <div className="spinner_container">
      <div className="spinner">
        <div className="rect1"></div>
        <div className="rect2"></div>
        <div className="rect3"></div>
        <div className="rect4"></div>
        <div className="rect5"></div>
      </div>
    </div>
  );
};

Loading.propTypes = {
  locale: PropTypes.string,
  size: PropTypes.string,
};

export default Loading;
